import React from "react";
import { useTranslation } from "react-i18next";

import { HvGlobalActions, HvGrid } from "@hitachivantara/uikit-react-core";

// eslint-disable-next-line import/named

import { UserDeviceAttribute } from "lib/api";
import useStyles from "./styles";
import DevicesTable from "./DevicesTable/DevicesTable";

interface DevicesProps {
  setRemovedDevices?: React.Dispatch<
    React.SetStateAction<UserDeviceAttribute[]>
  >;
  removedDevices?: UserDeviceAttribute[];
}

const Details: React.FC<DevicesProps> = ({
  setRemovedDevices,
  removedDevices,
}) => {
  const { t } = useTranslation("userAddEdit");
  const classes = useStyles();

  return (
    <HvGrid container className={classes.root}>
      <HvGrid xs={12} item>
        <HvGlobalActions title={t("devices.title")} variant="section" />
      </HvGrid>
      <DevicesTable
        setRemovedDevices={setRemovedDevices}
        removedDevices={removedDevices}
      />
    </HvGrid>
  );
};

export default Details;
